<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="page--login d-flex justify-center align-center">
          <div class="form-container">
            <v-card class="pa-10">
              <v-form ref="form">
                <v-row>
                  <v-col class="text-center">
                    <img
                      class="btn-logo-img"
                      src="https://cdn.educacao.pe.gov.br/storage/assets/logo_see_eleitoral_branco_c2003fd940.png"
                      alt="Brasão do state de Pernambuco"
                    />
                    <br />
                    <h1
                      class="subtitle-1 blue--text text--darken-4"
                      color="primary"
                      v-text="$appName || 'Acessar o Sistema'"
                    ></h1>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="user.username"
                      solo
                      hide-details="auto"
                      placeholder="CPF"
                      v-mask="'###.###.###-##'"
                      @keyup.enter="enter"
                      :rules="[
                        (v) => $required(v, 'CPF é obrigatória'),
                        (v) => $min(removeMask(v), 11),
                        (v) => $max(removeMask(v), 11),
                      ]"
                      ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="user.password"
                      type="password"
                      solo
                      placeholder="Senha"
                      hide-details="auto"
                      :rules="[
                        (v) => $required(v, 'Senha é obrigatória'),
                        (v) => $min(v, 8),
                        (v) => $max(v, 256),
                      ]"
                      @keyup.enter="enter"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <small>
                      <sca-recaptcha v-on:recaptchaVerified="verified = $event" />
                    </small>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col>
                    <v-btn
                      block
                      color="success"
                      :loading="loading"
                      @click.prevent="enter"
                    >
                      Entrar
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 mt-3 text-center">
                    <small>
                      <a @click="esqueciMinhaSenha()"> Esqueci minha senha </a>
                    </small>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0 mt-3 text-center">
                    <small>
                      <a @click="naoSouServidorNaoTenhoCadastro()">
                        Não sou servidor e não tenho cadastro
                      </a>
                    </small>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { LOGIN } from "store/modules/auth";
import { CLEAR } from "store";

export default {
  data: () => ({
    loading: false,
    verified: false,
    user: {
      username: undefined,
      password: undefined,
    },
  }),
  beforeMount() {
    this.hidePageLoading();
    this.$store.dispatch(CLEAR);
  },
  methods: {
    removeMask(value) {
      if (!value) return value;
      return value.replace(/\D/g, '');
    },
    enter() {
      if (this.$validarFormulario()) {
        if (!this.verified && this.$recaptchaDev) {
          return this.$notifyWarning("Conclua o reCAPTCHA para continuar.");
        }
        this.loading = true;
        const cpf = this.user.username.replace(/\D/g, '');
        this.$realizarLogin({
          nomeDeUsuario: cpf,
          senha: this.user.password,
        }).then(({ data }) => {
          if (!data.sad && data.primeiroAcesso) {
              sessionStorage.setItem('canAccessPrimeiroAcesso', 'true');
              return this.$router.push({ path: `/primeiro-acesso/${cpf}/${data.token}` })
            }
          this[LOGIN](data).then(() => {
            this.$atualizarCacheMenu().then(() => {
              this.$toHome();
            });
          });
        }).catch((data) => {
          const error = data.response.data;

          if(error.parecerPendente) {
            this.hideNotification();
            return this.$swal({
              text: error.mensagem,
              type: "info",
              showCancelButton: false,
              confirmButtonText: `OK`,
            }).then(() => {
              this.$store.dispatch(CLEAR);
              this.$router.push({ path: '/login' });
            });
          }
          if (error.parecerRecusado && !error.sad) {
            this.hideNotification();
            return this.$swal({
              text: error.mensagem,
              type: "warning",
              showCancelButton: true,
              confirmButtonText: `Sim`,
              cancelButtonText: `Não`,
            }).then(() => {
              this.$store.dispatch(CLEAR);
              sessionStorage.setItem('canAccessCadastroPedagogico', 'true');
              this.$router.push({ path: '/cadastro-pedagogico' });
            });
          }
          if (error.parecerRecusado && error.sad) {
            this.hideNotification();
            return this.$swal({
              text: error.mensagem,
              type: "warning",
              showCancelButton: true,
              confirmButtonText: `Sim`,
              cancelButtonText: `Não`,
            }).then(() => {
              this.$store.dispatch(CLEAR);
              return this.$realizarLogin({
                nomeDeUsuario: cpf,
                senha: this.user.password,
                novaSolicitacao: true
              }).then(({ data }) => {
                return this[LOGIN](data).then(() => {
                  this.$router.push({ path: '/cadastro-pedagogico/profissional' });
                });
              });
            });
          }
          this.$store.dispatch(CLEAR)
        })
        .finally(() => this.loading = false);
      }
    },
    esqueciMinhaSenha() {
      return this.$swal({
        text: `Você é servidor do Estado de Pernambuco?`,
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: `Sim`,
        cancelButtonText: `Não`,
      }).then((result) => {
        if (result) {
          window.open("https://www.nps.pe.gov.br/PORTALV2/#/", "_blank");
        }
      }).catch(() => this.$router.push({ path: '/esqueci-senha' }));
    },
    naoSouServidorNaoTenhoCadastro() {
      sessionStorage.setItem('canAccessCadastroPedagogico', 'true');
      this.$router.push({ path: '/cadastro-pedagogico' });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-logo-img {
  max-height: 80px;
}
.page--login {
  min-height: calc(100vh - 24px) !important;
  .form-container {
    form {
      min-width: 250px;
      a {
        text-decoration: none;
      }
    }
  }
}
</style>
